/** Splits entries into at most `columns` runs, in order, so that the runs are about equally tall: an entry is never cut, and counts as 1 plus the number of its own entries. Used to lay out a drop-down panel without letting a long family spill over two columns. */
export function balanceColumns<T extends { children?: unknown[] }>(items: readonly T[], columns: number): T[][] {
  const weight = (item: T) => 1 + (item.children?.length ?? 0);
  const total = items.reduce((sum, item) => sum + weight(item), 0);
  const runs: T[][] = [[]];
  let filled = 0;
  for (const item of items) {
    const run = runs[runs.length - 1];
    const target = (total * runs.length) / columns;
    // start a new column when this entry would end further past the target than the column ends short of it
    if (run.length > 0 && runs.length < columns && filled + weight(item) / 2 > target) runs.push([]);
    runs[runs.length - 1].push(item);
    filled += weight(item);
  }
  return runs;
}
